
/*
 * ! @chakra-ui/vue v0.12.0 by Jonathan Bakebwa @codebender828
 * MIT License
 * https://github.com/chakra-ui/chakra-ui-vue
 */

var formControlProps = {
  isInvalid: Boolean,
  isRequired: Boolean,
  isDisabled: Boolean,
  isReadOnly: Boolean
};

export { formControlProps as f };
